import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { _breakP } from './utils.js';

/**
 * 元の並び順(HTMLに書いた順)のインデックスを、現在の DOM 上の位置に読み替える。
 *
 * loop 有効時の Swiper はスライドを複製せず「実ノードを前後へ移動」させてループを作る。
 * slidesPerView:1 / slidesPerGroup:1 なら loopedSlides は 1 で、初期化直後から
 * 末尾のスライドが先頭へ回されるため DOM 順が1つずれる(以降も送るたびに入れ替わる)。
 * そのため data-*-index をそのまま slideTo() に渡すとボタンと中身が対応しない。
 *
 * Swiper は元の並び順を data-swiper-slide-index に残すので、そこから現在位置を引き直す。
 * loop 無効(スライド1枚)のときは属性が付かないため、そのまま元のインデックスを返す。
 */
const slidePosByOrder = (swiper, order) => {
  const pos = swiper.slides.findIndex(el => Number(el.dataset.swiperSlideIndex) === order);
  return pos === -1 ? order : pos;
};

export default class generalSlider {
  constructor() {
    this.generalSliderFunc();
    this.fadeSliderFunc();
    this.roomplanDetailFunc();
    this.floorplanDetailFunc();
  }

  generalSliderFunc() {
    const $generalSlider = document.querySelectorAll('.js-generalSlider');

    if ($generalSlider.length) {
      window.addEventListener('load', function() {
        $generalSlider.forEach(elm => {
          const i = [].slice.call($generalSlider).indexOf(elm),
            elSlideLength = elm.querySelectorAll('.swiper-slide').length,
            minSliderLength = _breakP.SP ? Number(elm.dataset.spMinSlides) : Number(elm.dataset.pcMinSlides);

          function slideInit() {
            const imgArr = elm.querySelectorAll('.swiper-slide img');
            imgArr.forEach(elm => {
              if (elm.classList.contains('lazy')) {
                elm.setAttribute('src', elm.dataset.src);
                elm.classList.remove('lazy');
              }
            });

            elm.classList.add('generalSlider--' + i);

            const patternArr01 = {
              modules: [Navigation, Pagination, Autoplay],
              loop: true,
              pagination: {
                el: '.generalSlider--' + i + ' .swiper-pagination',
                type: 'bullets'
              },
              navigation: {
                nextEl: '.generalSlider--' + i + ' .js-generalSliderNext',
                prevEl: '.generalSlider--' + i + ' .js-generalSliderPrev'
              },
              autoplay: {
                delay: 4000,
                disableOnInteraction: false
              },
              slidesPerView: elm.dataset.spSlidesPerView,
              spaceBetween: Number(elm.dataset.spSpaceBetween),
              loopAdditionalSlides: Number(elSlideLength),
              speed: 2000,
              simulateTouch: true,
              allowTouchMove: true,
              grabCursor: true,
              centeredSlides: elm.dataset.centerMode === 'on' ? true : false,
              breakpoints: {
                768: {
                  slidesPerView: elm.dataset.pcSlidesPerView,
                  spaceBetween: Number(elm.dataset.pcSpaceBetween),
                  centeredSlides: false
                }
              }
            };
            new Swiper(`.generalSlider--${i} .swiper`, patternArr01);
          }

          function slideDisable() {
            elm.classList.add('generalSlider--disableMode');
          }

          elSlideLength >= minSliderLength ? slideInit() : slideDisable();
        });
      });
    }
  }

  fadeSliderFunc() {
    const $fadeSlider = document.querySelectorAll('.js-fadeSlider');

    if ($fadeSlider.length) {
      window.addEventListener('load', function() {
        $fadeSlider.forEach(elm => {
          const i = [].slice.call($fadeSlider).indexOf(elm),
            elSlideLength = elm.querySelectorAll('.swiper-slide').length,
            minSliderLength = _breakP.SP ? Number(elm.dataset.spMinSlides) : Number(elm.dataset.pcMinSlides);

          function slideInit() {
            const imgArr = elm.querySelectorAll('.swiper-slide img');
            imgArr.forEach(elm => {
              if (elm.classList.contains('lazy')) {
                elm.classList.remove('lazy');
                elm.classList.add('swiper-lazy');
              }
            });

            elm.classList.add('fadeSlider--' + i);

            const patternArr01 = {
              modules: [Pagination, Autoplay, EffectFade],
              effect: 'fade',
              loop: true,
              pagination: {
                el: '.fadeSlider--' + i + ' .swiper-pagination',
                type: 'bullets'
              },
              autoplay: {
                delay: 4000,
                disableOnInteraction: false
              },
              slidesPerView: 1,
              spaceBetween: 0,
              loopAdditionalSlides: Number(elSlideLength),
              speed: 2000,
              simulateTouch: true,
              allowTouchMove: true,
              grabCursor: true
            };
            new Swiper(`.fadeSlider--${i} .swiper`, patternArr01);
          }

          function slideDisable() {
            elm.classList.add('fadeSlider--disableMode');
          }

          elSlideLength >= minSliderLength ? slideInit() : slideDisable();
        });
      });
    }
  }

  // ROOM PLAN 間取り詳細モーダル内の Swiper。
  // modal.js(DOMContentLoaded) が .js-modalCont を outerHTML で .currentPage 直下へ複製移動するため、
  // 初期化は移動後の実ノードに対して行う必要がある(load フックなら順序は満たされる)。
  roomplanDetailFunc() {
    window.addEventListener('load', function() {
      const $detail = document.querySelector('.js-roomplanDetail');

      if (!$detail) return;

      const elSlideLength = $detail.querySelectorAll('.swiper-slide').length;

      if (!elSlideLength) return;

      // モーダル内は縦長の間取図を縦スクロールして読む面。
      // Swiper は既定で simulateTouch/touchStartPreventDefault が有効なため、
      // Mac トラックパッドの2本指スクロールが pointerdown → preventDefault で
      // 掴まれてしまい、親(.generalModal__inner)の縦スクロールが途切れる。
      // PC は送り矢印で操作する設計なのでドラッグ送りを切り、縦スクロールを優先する。
      // SP はスワイプ送りを残し、縦方向の指移動は Swiper 側にスクロールを譲らせる。
      const isSp = _breakP.SP || _breakP.TB;

      const swiper = new Swiper($detail.querySelector('.roomplanDetail__slider'), {
        modules: [Navigation],
        loop: elSlideLength >= 2,
        slidesPerView: 1,
        speed: 600,
        allowTouchMove: isSp,
        simulateTouch: isSp,
        touchStartPreventDefault: false,
        touchReleaseOnEdges: true,
        navigation: {
          prevEl: $detail.querySelector('.roomplanDetail__prev'),
          nextEl: $detail.querySelector('.roomplanDetail__next')
        }
      });

      // 押されたタイプのスライドを開く。モーダル表示は modal.js 側が担当。
      document.querySelectorAll('.js-roomplanList .js-modalBtn').forEach(btn => {
        btn.addEventListener('click', () => {
          const index = Number(btn.dataset.planIndex);
          if (Number.isNaN(index)) return;
          swiper.slideTo(slidePosByOrder(swiper, index), 0);
        });
      });

      // 1枚のみのときは送り矢印を隠す
      if (elSlideLength < 2) {
        $detail.querySelectorAll('.roomplanDetail__prev, .roomplanDetail__next').forEach(elm => {
          elm.style.display = 'none';
        });
      }
    });
  }

  // ROOM PLAN 各階平面図モーダル内の Swiper。
  // roomplanDetailFunc と同じ理由で、modal.js が複製移動した後の実ノードに対して
  // load フックで初期化する。
  floorplanDetailFunc() {
    window.addEventListener('load', function() {
      const $detail = document.querySelector('.js-floorplanDetail');

      if (!$detail) return;

      const elSlideLength = $detail.querySelectorAll('.swiper-slide').length;

      if (!elSlideLength) return;

      // PC は送り矢印で操作する設計。ドラッグ送りを切って
      // 親(.generalModal__inner)の縦スクロールを優先させる。
      // SP はスワイプ送りを残す。
      const isSp = _breakP.SP || _breakP.TB;

      const swiper = new Swiper($detail.querySelector('.floorplanDetail__slider'), {
        modules: [Navigation],
        loop: elSlideLength >= 2,
        slidesPerView: 1,
        speed: 600,
        allowTouchMove: isSp,
        simulateTouch: isSp,
        touchStartPreventDefault: false,
        touchReleaseOnEdges: true,
        navigation: {
          prevEl: $detail.querySelector('.floorplanDetail__prev'),
          nextEl: $detail.querySelector('.floorplanDetail__next')
        }
      });

      // 押された階のスライドを開く。モーダル表示は modal.js 側が担当。
      document.querySelectorAll('.js-floorplanList .js-modalBtn').forEach(btn => {
        btn.addEventListener('click', () => {
          const index = Number(btn.dataset.floorIndex);
          if (Number.isNaN(index)) return;
          swiper.slideTo(slidePosByOrder(swiper, index), 0);
        });
      });

      // 1枚のみのときは送り矢印を隠す
      if (elSlideLength < 2) {
        $detail.querySelectorAll('.floorplanDetail__prev, .floorplanDetail__next').forEach(elm => {
          elm.style.display = 'none';
        });
      }
    });
  }
}
